module.exports = __webpack_public_path__ + "media/landing_page/hero-mobile-2-c87c0e43.jpg";